import { Icon } from 'components/Icon';
import { theme } from 'ui/theme-color';
import { ProposalCurationVerticalDivider } from './ProposalCurationVerticalDivider';
import { ProposalCurationBannerContainer } from './styled';

export const ProposalCurationBanner = ({ status }) => {
  const isRecused = status === 'Recusado';
  const bannerColor = isRecused
    ? theme.palette.error.main
    : theme.palette.purple.main;

  return (
    <ProposalCurationBannerContainer color={bannerColor}>
      <Icon
        name={isRecused ? 'gpp_bad' : 'policy'}
        size={36}
        elementAttributes={{
          style: { fontWeight: 200 },
        }}
      />
      <ProposalCurationVerticalDivider color={bannerColor} />
      {isRecused
        ? 'Esta proposta foi recusada em curadoria.'
        : 'Esta proposta encontra-se em curadoria.'}
    </ProposalCurationBannerContainer>
  );
};
